import React from 'react'
import { Bell, User, Menu } from 'lucide-react'
import { useAuth } from '../hooks/useAuth.jsx'

const Header = ({ onMenuClick }) => {
  const { logout } = useAuth()

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Left side */}
        <div className="flex items-center space-x-4">
          {/* Mobile menu button */}
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200"
          >
            <Menu className="w-6 h-6" />
          </button>
          
          <h1 className="text-lg lg:text-xl font-semibold text-gray-900">
            Admin Dashboard
          </h1>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-2 lg:space-x-4">
          {/* Notifications */}
          <button className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all duration-200">
            <Bell className="w-5 h-5" />
          </button>

          {/* User menu */}
          <div className="relative">
            <button className="flex items-center space-x-2 p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200">
              <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center shadow-sm">
                <User className="w-4 h-4 text-primary-600" />
              </div>
              <span className="hidden sm:block text-sm font-medium">Admin</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
